import IDream from "motw_core/Entity/IDream";
import * as React from "react";
import { clearedDreamFilters } from "source/app/presentation/MainPanel/Dreams/DreamFilterButtons/Helpers/clearedDreamFilters";
import { EEventType } from "source/app/services/Events/EEventType";
import { DispatchEvent } from "source/app/services/Events/Events";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { resourceNameDream } from "../../../../../../motw_core/Entity/IDream";
import Nameof from "../../../services/NameOf";
import IsNotEqual from "../../../services/Shared/ReactHelpers";
import { LoadingSpinner } from "../Calendar/LoadingSpinner";
import Data from "./../../../services/Data";
import { DreamFilter } from "./DreamFilter";
import { FlushRandomDreamsCache } from "./DreamHelpers/GetRandomDream";
import { DreamsView } from "./DreamsView/DreamsView";
import { IDreamsState } from "./IDreamsState";
import { RouteDreams } from "./Routing/DreamsRouting";

export class Dreams extends React.Component<{}, IDreamsState> {
    constructor(props: {}) {
        super(props);

        this.state = {
            ...clearedDreamFilters,
            onlyShowTodaysDreams: true,
            dreamsdata: [],
            sortedData: [],
            filteredData: [],
            selectedDifficulty: 5,
            randomDream: undefined,
            isLoading: true,
        };
    }

    async LoadDreamsAsync() {
        await Data.Load.Component({
            component: this,
            load: async () => {
                const dreams =
                    await ClientDataProvider.GetRecordsAsync<IDream>(
                        resourceNameDream
                    );

                return Array.isArray(dreams) ? dreams : [];
            },
            stateTarget: Nameof<IDreamsState>("dreamsdata"),
            inLoadAll: true,
        });

        this.setState({ isLoading: false });
    }

    async componentDidMount() {
        this.LoadDreamsAsync();
        State.ShareClass(ESharedComponent.Dreams, this);
        const pathSegments = window.location.pathname
            .split(`/`)
            .filter(Boolean);
        const dreamsRouteIndex = pathSegments.findIndex(
            (segment) => segment.toLowerCase() === `dreams`
        );

        RouteDreams(pathSegments[dreamsRouteIndex + 1]);
    }

    async componentDidUpdate(prevProps: {}, prevState: IDreamsState) {
        this.SortDreams(this.state.dreamsdata);
        this.FilterDreams();

        const haveFiltersBeeenReset =
            this.state.randomDream === undefined &&
            prevState.randomDream !== undefined;

        if (haveFiltersBeeenReset) {
            FlushRandomDreamsCache();
        }

        State.ShareClass(ESharedComponent.Dreams, this);
        DispatchEvent(EEventType.Dreams_DataChanged);
    }

    SortDreams(data: IDream[]) {
        const preSortedData: IDream[] = Object.assign([], data);

        const sortedData: IDream[] = preSortedData.sort(
            (a: IDream, b: IDream) => b.difficulty - a.difficulty
        );

        this.setState({ sortedData });
    }

    FilterDreams() {
        const inputDreams = this.state.sortedData;
        const inputFilters = DreamFilter.allFilters;

        let filteredDreams: IDream[] = inputDreams;

        console.log(`[Dreams] Started filtering...`);
        const filterStart = performance.now();

        inputFilters.forEach((filter) => {
            var dreamsAfterSingleFilter: IDream[] = [];

            filteredDreams.forEach((dream) => {
                var didPassFilter = filter(dream, this.state);

                if (didPassFilter) {
                    dreamsAfterSingleFilter.push(dream);
                }
            });

            filteredDreams = dreamsAfterSingleFilter;
            console.log(
                `[Dreams] finished filter '${filter.name}' and ${filteredDreams.length} dreams are left`
            );
        });

        this.setState({ filteredData: filteredDreams });

        const filterDuration = performance.now() - filterStart;
        const elapsedMs = filterDuration.toFixed(2);
        const completionMessage = `[Dreams] Finished filtering in ${elapsedMs}ms`;
        console.log(completionMessage);
    }

    // Required to prevent unncessary renders
    // when Data.Load.All() is called
    shouldComponentUpdate(nextProps: {}, nextState: IDreamsState) {
        return (
            IsNotEqual(nextProps, this.props) ||
            IsNotEqual(nextState, this.state)
        );
    }

    render() {
        if (this.state.isLoading) {
            return <LoadingSpinner />;
        }

        return <DreamsView dreams={this} />;
    }
}

export default Dreams;
